<template>
  <div class="home">
    <heade />

    <home-slider />
    <home-bottom />
    <!-- <div class="back">
    <div class="content">
      <img src="../assets/img/C1_1.png" alt="">
    </div>
    </div> -->
  </div>
</template>

<script>
import Heade from "../components/Heade.vue";
import HomeBottom from "../components/HomeBottom.vue";
import HomeSlider from "../components/HomeSlider.vue";

export default {
  components: { Heade, HomeSlider, HomeBottom },
  name: "Home",
  data() {
    return {
      prj: [],
    };
  },
  methods: {
    async getContent() {
      // Query the API and assign the response to "response"
      const response = await this.$prismic.client.query(
        this.$prismic.Predicates.at("document.type", "project")
      );
      // const response = await this.$prismic.client.query(
      //   this.$prismic.Predicates.at("document.type", "project"),
      //   { orderings: "[my.work.date_creation desc]" }
      // );
      console.log(response.results);
      response.results.forEach((el) => {
        // console.log(el)
        this.prj.push(el);
      });
      this.$store.commit("pushPrj", this.prj);
      // console.log(this.worksa);
    },
  },
  created() {
    // Call the API query method
    this.getContent();
  },
  mounted() {
    // First we get the viewport height and we multiple it by 1% to get a value for a vh unit
    let vh = window.innerHeight * 0.01;
    // Then we set the value in the --vh custom property to the root of the document
    document.documentElement.style.setProperty("--vh", `${vh}px`);
  },
};
</script>

<style lang="scss" scoped>
.home {
  color: white;
  height: 100vh;
  width: 100vw;
  background: black;
  @media screen and (max-width: 767px) {
  height: 100vh; /* Use vh as a fallback for browsers that do not support Custom Properties */
  height: calc(var(--vh, 1vh) * 100);
  }
}
.back {
  width: 100%;
  height: 100%;
  background: #000;
  // opacity: 0.5;
  // background-blend-mode: screen;
}

.back:before {
  --size: 0;
  content: "";
  position: absolute;
  left: var(--x);
  top: var(--y);
  width: var(--size);
  height: var(--size);
  background: radial-gradient(circle closest-side, #fff5, transparent);
  transform: translate(-50%, -50%);
  transition: width 0.2s ease, height 0.2s ease;
  overflow: hidden;
}

.back:hover:before {
  --size: 400px;
}
.content {
  mix-blend-mode: multiply;
  opacity: 1;
}
</style>
